var _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 19,
      height: 20
    },
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.424316,
    y1: 10.2311,
    x2: 18.9246,
    y2: 10.2311,
    stroke: "#1D1D1F",
    strokeWidth: 2.8462
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.67432,
    y1: 0.981201,
    x2: 9.67432,
    y2: 19.4815,
    stroke: "#1D1D1F",
    strokeWidth: 2.8462
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.440c3647797da64b75f11724239beae1.svg";
export { ForwardRef as ReactComponent };